export default __webpack_public_path__ + "static/media/top-point-sep.6b49f93d.svg";